module.exports = __webpack_public_path__ + "menu_0_active.d2811844.png";